const students = {
  students: "Élèves",
  definePassword: "Définir un mot de passe",
  pendingActivation: "En attente d'activation",
  passwordRequired: "mot de passe requis",
  student: "Élève",
  studentDetail: "Détails élève",
  studentsList: "Liste des élèves",
  newStudentsList: "Liste des nouveaux élèves",
  importStudents: "Importer des élèves",
  welcomeStudentPersonalHome: "Bienvenue sur ton espace personnel",
  selectStudentInList: "Sélectionnez un élève existant dans la liste.",
  studentNotActivated: "Cet élève n'a pas activé son compte.",
  studentNotSubscribed: "Cet élève n'est pas abonné.",
};

export default students;
